import { IGenerateDeviceCodeService } from './IGenerateDeviceCodeService';
import { GenerateUlidCode } from './generateUlidDeviceCode';

export class DeviceCodeServiceBuilder {
    public static Instance(): IGenerateDeviceCodeService {
        return new GenerateUlidCode();
    }
}
